import authorizedAxios from "../../helpers/authorizedAxios";
import { showToast } from "../../utils/helpers/ShowToast";

export const SET_CASH_BANK = "SET_CASH_BANK";
export const SET_CASH_BANK_DETAIL = "SET_CASH_BANK_DETAIL";
export const SET_CASH_BANK_LOADING = "SET_CASH_BANK_LOADING";
export const SET_CASH_BANK_ACTION_LOADING = "SET_CASH_BANK_ACTION_LOADING";
export const SET_CASH_BANK_ERROR = "SET_CASH_BANK_ERROR";

const errorMessage = (error, fallback) => error?.response?.data?.message || error?.message || fallback;

const setError = (dispatch, error, fallback) => {
  dispatch({ type: SET_CASH_BANK_ERROR, error: errorMessage(error, fallback) });
};

const mutate = (request, messages) => async (dispatch) => {
  dispatch({ type: SET_CASH_BANK_ACTION_LOADING, status: true });
  try {
    const response = await showToast(request(), {
      ...messages,
      error: (error) => errorMessage(error, messages.error),
    });
    return response?.data?.data ?? true;
  } catch (error) {
    setError(dispatch, error, messages.error);
    return null;
  } finally {
    dispatch({ type: SET_CASH_BANK_ACTION_LOADING, status: false });
  }
};

export const fetchCashBank = (params = {}) => async (dispatch) => {
  dispatch({ type: SET_CASH_BANK_LOADING, status: true });
  try {
    const response = await authorizedAxios.get("/cash-bank", { params });
    dispatch({ type: SET_CASH_BANK, data: response?.data?.data });
    return response?.data?.data;
  } catch (error) {
    setError(dispatch, error, "Data Kas & Bank gagal dimuat.");
    return null;
  } finally {
    dispatch({ type: SET_CASH_BANK_LOADING, status: false });
  }
};

export const fetchPosPaymentAccount = (method = "transfer") => async () => {
  try {
    const response = await authorizedAxios.get(`/pos/payment-accounts/${method}`);
    return response?.data?.data || null;
  } catch (error) {
    return {
      method,
      is_configured: false,
      account: null,
      error: errorMessage(error, "Informasi rekening pembayaran gagal dimuat."),
    };
  }
};

export const fetchCashBankDetail = (id, params = {}) => async (dispatch) => {
  dispatch({ type: SET_CASH_BANK_LOADING, status: true });
  try {
    const response = await authorizedAxios.get(`/cash-bank/accounts/${id}`, { params });
    dispatch({ type: SET_CASH_BANK_DETAIL, data: response?.data?.data });
    return response?.data?.data;
  } catch (error) {
    setError(dispatch, error, "Detail akun gagal dimuat.");
    return null;
  } finally {
    dispatch({ type: SET_CASH_BANK_LOADING, status: false });
  }
};

export const addCashBankAccount = (payload) => mutate(
  () => authorizedAxios.post("/cash-bank/accounts", payload),
  { loading: "Menambahkan akun...", success: "Akun Kas & Bank berhasil ditambahkan.", error: "Akun gagal ditambahkan." },
);

export const updateCashBankAccount = (id, payload) => mutate(
  () => authorizedAxios.put(`/cash-bank/accounts/${id}`, payload),
  { loading: "Memperbarui akun...", success: "Akun Kas & Bank berhasil diperbarui.", error: "Akun gagal diperbarui." },
);

export const deactivateCashBankAccount = (id) => mutate(
  () => authorizedAxios.delete(`/cash-bank/accounts/${id}`),
  { loading: "Menonaktifkan akun...", success: "Akun berhasil dinonaktifkan.", error: "Akun gagal dinonaktifkan." },
);

export const addCashBankEntry = (payload) => mutate(
  () => authorizedAxios.post("/cash-bank/entries", payload),
  { loading: "Mencatat mutasi...", success: "Mutasi Kas & Bank berhasil dicatat.", error: "Mutasi gagal dicatat." },
);

export const transferCashBank = (payload) => mutate(
  () => authorizedAxios.post("/cash-bank/transfers", payload),
  { loading: "Memproses transfer...", success: "Transfer antar akun berhasil.", error: "Transfer gagal diproses." },
);

export const reconcileCashBank = (payload) => mutate(
  () => authorizedAxios.post("/cash-bank/reconciliations", payload),
  { loading: "Memproses opname...", success: "Opname Kas & Bank berhasil diproses.", error: "Opname gagal diproses." },
);
